import { getFlightItemViewLuxPlusRegularPrice, getFlightItemsView } from 'checkout/selectors/view/flights'
import { sum } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import { getIsEnabledFlightsLuxPlusPricing } from '../featureToggle'

export const getAvailableFlightBenefits = createSelector(
  (state: App.State) => getFlightItemsView(state),
  (state: App.State) => getIsEnabledFlightsLuxPlusPricing(state),
  (flightItemsView, isFlightsLuxPlusPricingEnabled): App.Checkout.BaseDiscountedPricingBenefit => {
    if (!isFlightsLuxPlusPricingEnabled) {
      return {
        totalPrice: 0,
        totalBaseMemberPrice: 0,
        totalMemberPrice: 0,
        totalMemberPriceSavings: 0,
      }
    }

    const standaloneItems = flightItemsView.data.filter(itemView => !itemView.isBundled)

    const totalPrice = sum(standaloneItems, itemView => getFlightItemViewLuxPlusRegularPrice(itemView) ?? itemView.totals.price)
    const totalMemberPrice = sum(standaloneItems, itemView => itemView.totals.price)
    const totalBaseMemberPrice = sum(standaloneItems, itemView => {
      const regularPrice = getFlightItemViewLuxPlusRegularPrice(itemView)
      if (regularPrice === undefined) {
        return 0
      }

      return itemView.totals.price
    })
    const totalMemberPriceSavings = sum(standaloneItems, itemView => {
      const regularPrice = getFlightItemViewLuxPlusRegularPrice(itemView)
      if (regularPrice === undefined) {
        return 0
      }

      return Math.max(regularPrice - itemView.totals.price, 0)
    })

    return {
      totalPrice,
      totalBaseMemberPrice,
      totalMemberPrice,
      totalMemberPriceSavings,
    }
  },
)
